// extracted by mini-css-extract-plugin
export var box = "_9g-1";
export var checkboxRow = "_9g-8";
export var checked = "_9g-2";
export var descriptionSpacer = "_9g-a";
export var disabled = "_9g-3";
export var icon = "_9g-6";
export var input = "_9g-0";
export var labelSpacer = "_9g-9";
export var medium = "_9g-5";
export var small = "_9g-4";
export var text = "_9g-7";